import { create } from "zustand";

interface SupportStore {
  open: boolean;
  /** Viewport-top of the element that opened the panel, so it aligns with its
   *  trigger. Null → the panel centers itself next to the sidebar. */
  anchorTop: number | null;
  /** Pre-fill for an opener that knows the subject. `label` is an `InquiryType`
   *  the server routes on. Cleared on close. */
  seed: { subject?: string; label?: string } | null;
  openSupport: (
    anchorTop?: number,
    seed?: { subject?: string; label?: string },
  ) => void;
  closeSupport: () => void;
}

export const useSupportStore = create<SupportStore>((set) => ({
  open: false,
  anchorTop: null,
  seed: null,
  openSupport: (anchorTop, seed) =>
    set({ open: true, anchorTop: anchorTop ?? null, seed: seed ?? null }),
  closeSupport: () => set({ open: false, seed: null }),
}));
